(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-contact-country]')) return;
    const country = event.target;
    const option = country.selectedOptions[0];
    country.parentElement.querySelector('.ruu-contact-country-display').textContent = `${option.value} +${option.dataset.code} ▾`;
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.contact-form__form')) return;
    const country = form.querySelector('[data-contact-country]');
    const phone = form.querySelector('[name="contact[phone]"]');
    if (country && phone && phone.value.trim() && !phone.value.trim().startsWith('+')) {
      const code = country.selectedOptions[0].dataset.code;
      let digits = phone.value.replace(/\D/g, '');
      if (code === '1' && digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
      phone.value = `+${code} ${digits}`;
    }
    const trap = form.querySelector('[data-contact-trap]');
    if (trap && trap.value.trim()) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
